/* Login */
import Home from "./Home.vue";

export const homeRouting = {
  path: "/home",
  name: "Home",
  component: Home,
  meta: {
    layout: "Restricted"
  }
};
